<template>
  <div v-if="item.type === 'text'">
    <pop-up-text-group :item="item"></pop-up-text-group>
  </div>
  <div v-else-if="item.type === 'table'">
    <pop-up-table :item="item"></pop-up-table>
  </div>
  <div v-else-if="item.type === 'table_with_datatable'">
    <PopUpTableWithDatatable :item="item"></PopUpTableWithDatatable>
  </div>
  <div v-else-if="item.type === 'datatable'">
    <PopUpDataTable :item="item"></PopUpDataTable>
  </div>
  <div v-else-if="item.type === 'timeline'">
    <pop-up-time-line :item="item"></pop-up-time-line>
  </div>
  <div v-else-if="item.type === 'docs'">
    <PopUpDocs :item="item"></PopUpDocs>
  </div>
  <div v-else-if="item.type === 'tab-json'">
    <tab-json :item="item"></tab-json>
  </div>
  <div v-else-if="item.type === 'datatable_with_object'">
    <PopUpDataTableObject
      ref="dataFetchable"
      :id="id"
      :itemprop="item"
      :updateDetailsData="refresher"
    />
  </div>
</template>

<script>
import PopUpTable from "@/own/components/datatable/popup/PopUpTable.vue";
import PopUpTableWithDatatable from "@/own/components/datatable/popup/PopUpTableWithDatatable.vue";
import PopUpDataTable from "@/own/components/datatable/popup/PopUpDataTable.vue";
import PopUpTextGroup from "@/own/components/datatable/popup/PopUpTextGroup.vue";
import PopUpDocs from "@/own/components/datatable/popup/PopUpDocs.vue";
import PopUpTimeLine from "@/own/components/datatable/popup/PopUpTimeLine.vue";
import TabJson from "@/own/components/datatable/popup/TabJson.vue";
import PopUpDataTableObject from "@/own/components/fulfillment/orders/popup/PopUpDataTableObject.vue";
export default {
  name: "PopUpSelector",
  props: ["item", "id", "refresher"],
  components: {
    PopUpDataTableObject,
    PopUpTable,
    PopUpTextGroup,
    PopUpTimeLine,
    PopUpDocs,
    PopUpDataTable,
    TabJson,
    PopUpTableWithDatatable,
  },
};
</script>

<style></style>
